module.exports = __webpack_public_path__ + "img/header.35f550bf.png";